module.exports = __webpack_public_path__ + "assets/img/array2.a5ae66a2.svg";